// Centralized pool of default genie images and helpers for selection.
//
// Migrated to the new /genie-mascots/ library. See src/data/brandMascots.ts
// for the canonical constants and legacy-path resolver.

import { BRAND_MASCOT_CONCIERGE, BRAND_MASCOT_POOL } from "@/data/brandMascots";

export const GENIE_DEFAULT_IMAGE_URLS: string[] = [
  ...BRAND_MASCOT_POOL,
  BRAND_MASCOT_CONCIERGE,
];

export function getRandomGenieDefaultImage(): string {
  const pool = GENIE_DEFAULT_IMAGE_URLS;
  const index = Math.floor(Math.random() * pool.length);
  return pool[index];
}

export function getSeededGenieDefaultImage(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0;
  }
  const index = Math.abs(hash) % GENIE_DEFAULT_IMAGE_URLS.length;
  return GENIE_DEFAULT_IMAGE_URLS[index];
}
